// extracted by mini-css-extract-plugin
export var table = "_vz-0";